module.exports = __webpack_public_path__ + "media/images/dashbard4_1-da34e078194e7e9949aca8b5178b53e3.jpg";